import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadedDirective } from '../directive/img-preload.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingScreenComponent } from './pages/loading-screen/loading-screen.component';
import { ErrorToastComponent } from './shared/error-toast/error-toast.component';
import { LayerComponent } from './shared/layer/layer.component';

@NgModule({
  declarations: [AppComponent, LoadingScreenComponent, LayerComponent],
  imports: [BrowserModule, AppRoutingModule, NgbModule, LoadedDirective, ErrorToastComponent],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
